import { BrowserModule, HammerModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { NgxPayPalModule } from 'ngx-paypal';
// import { NgFallimgModule } from 'ng-fallimg';
import { FallimgDirective } from './helpers/fallimg.directive';
import { FallimgModule } from './helpers/fallimg.module';

/**
 * JWT
 */
import { JwtInterceptor } from './helpers/jwt.interceptor';

/**
 * Components
 */
import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { MaterialModule } from './material/material.module';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FooterComponent } from './components/shared/footer/footer.component';
import { HeaderComponent } from './components/shared/header/header.component';
import { LoginComponent } from './components/shared/login/login.component';
import { RegisterComponent } from './components/shared/register/register.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CardsModule } from './components/bloques/cards.module';
import { EventComponent } from './components/event/event.component';
import { SwiperModule } from 'swiper/angular';
import { SearchComponent } from './components/search/search.component';
import { CategoryPageComponent } from './components/categories/category-page/category-page.component';
import { NotFoundPageComponent } from './components/shared/not-found-page/not-found-page.component';
import { LottieModule } from 'ngx-lottie';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import localeEs from '@angular/common/locales/es';
import { PaginatorResultsComponent } from './components/shared/paginator-results/paginator-results.component';
import { PrivacyComponent } from './components/shared/static-pages/privacy/privacy.component';
import { CookiesComponent } from './components/shared/cookies/cookies.component';
import { FiltersComponent } from './components/shared/filters/filters.component';
import { CustomCalendarComponent } from './components/shared/custom-calendar/custom-calendar.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { PageOwnerComponent } from './components/page-owner/page-owner.component';

import { ContactFormComponent } from './components/shared/static-pages/contact-form/contact-form.component';
import { SuggestionsComponent } from './components/shared/static-pages/suggestions/suggestions.component';
import { WarningComponent } from './components/shared/warning/warning.component';
import { TermsConditionsComponent } from './components/shared/static-pages/terms-conditions/terms-conditions.component';
import { FaqsComponent } from './components/shared/static-pages/faqs/faqs.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { WhoWeAreComponent } from './components/who-we-are/who-we-are.component';
import { CityblogComponent } from './components/blog/cityblog/cityblog.component';
import { DetailPodsComponent } from './components/blog/detail-pods/detail-pods.component';
import { LastPostsComponent } from './components/blog/last-posts/last-posts.component';
import { ListMapComponent } from './components/list-map/list-map.component';
import { InfoCardComponent } from './components/shared/info-card/info-card.component';
import { MapSearchComponent } from './components/new-lok/map-search/map-search.component';
import { DescriptionLokComponent } from './components/new-lok/description-lok/description-lok.component';
import { MainMenuComponent } from './components/shared/main-menu/main-menu.component';
import { StepCheckoutComponent } from './components/checkout/step-checkout/step-checkout.component';
import { ConfirmPayComponent } from './components/checkout/confirm-pay/confirm-pay.component';
import { WaitingPayComponent } from './components/checkout/waiting-pay/waiting-pay.component';
import { CheckoutPageComponent } from './components/checkout/checkout-page/checkout-page.component';
import { DatesHoursComponent } from './components/new-lok/dates-hours/dates-hours.component';
import { NewTicketComponent } from './components/new-lok/new-ticket/new-ticket.component';
import { ProfileComponent } from './components/profile/profile/profile.component';
import { FavoritesComponent } from './components/profile/favorites/favorites.component';
import { ProfileFavComponent } from './components/profile/profile-fav/profile-fav.component';
import { EventsFavComponent } from './components/profile/events-fav/events-fav.component';
import { InteresesComponent } from './components/profile/config/intereses/intereses.component';
import { EditProfileComponent } from './components/profile/config/edit-profile/edit-profile.component';
import { NotificationsComponent } from './components/profile/config/notifications/notifications.component';
import { MyMembershipComponent } from './components/profile/config/my-membership/my-membership.component';
import { AbonoCardComponent } from './components/profile/config/my-membership/abono-card/abono-card.component';
import { SeasonPassSignupComponent } from './components/season-pass-signup/season-pass-signup.component';
// Pantalla de plazo cerrado: desactivada al reabrir el plazo el 05-10-2026, ver
// la ruta 'alta-abono' en app-routing. El componente sigue en el repo.
// import { SeasonPassSignupClosedComponent } from './components/season-pass-signup-closed/season-pass-signup-closed.component';
// Renovación por carné: desactivada 31-08-2026, ver la ruta 'vincular-abono'
// en app-routing. El componente sigue en el repo.
// import { LinkMembershipCardComponent } from './components/link-membership-card/link-membership-card.component';
import { TicketsProfileComponent } from './components/profile/config/tickets-profile/tickets-profile.component';
import { TicketDetailComponent } from './components/profile/config/ticket-detail/ticket-detail.component';
import { TicketsListComponent } from './components/profile/config/tickets-list/tickets-list.component';
import { EventsListComponent } from './components/profile/config/events-list/events-list.component';
import { ChangePasswordComponent } from './components/profile/config/change-password/change-password.component';
import { InputHourComponent } from './components/shared/input-hour/input-hour.component';
import { DefaultCalendarComponent } from './components/new-lok/default-calendar/default-calendar.component';
import { CardValidateComponent } from './components/profile/card-validate/card-validate.component';
// import { HideEventComponent } from './components/shared/hide-event/hide-event.component';
import { LegalComponent } from './components/shared/static-pages/legal/legal.component';
import { CookiesTermsComponent } from './components/shared/static-pages/cookies-terms/cookies-terms.component';
import { SeatMapModule } from './components/seat-map/seat-map.module';
import { ImageMapComponent } from './components/shared/image-map/image-map.component';
import { CartCheckoutComponent } from './components/profile/cart-checkout/cart-checkout.component';
import { SeasonPassCheckoutComponent } from './components/profile/season-pass-checkout/season-pass-checkout.component';
import { NewPasswordComponent } from './components/shared/new-password/new-password.component';
import { NominativeHolderComponent } from './components/shared/nominative-holder/nominative-holder.component';
import { ControlPanelModule } from './components/control-panel/control-panel.module';
import { SubscriberFrontComponent } from './components/subscriber-front/subscriber-front.component';
import { ChangeNameComponent } from './components/profile/config/change-name/change-name.component';
import { StatusPayComponent } from './components/checkout/status-pay/status-pay.component';
import { SubscriptionsComponent } from './components/profile/config/subscriptions/subscriptions.component';
import { PaylandsTemplateComponent } from './components/checkout/paylands-template/paylands-template.component';
import { CreateEventComponent } from './components/control-panel/events/create-event/create-event.component';
import { PaymentSuccessComponent } from './components/checkout/payment-success/payment-success.component';
import { PaymentErrorComponent } from './components/checkout/payment-error/payment-error.component';
import { PaymentFailedDialogComponent } from './components/checkout/payment-failed-dialog/payment-failed-dialog.component';
import { ChatbotComponent } from './components/shared/chatbot/chatbot.component';
import { InfoConditionsComponent } from './components/profile/info-conditions/info-conditions.component';
import { TotemModule } from './components/totem/totem.module';
import { SharedModule } from './components/shared/shared.module';
import { PaymentMethodsComponent } from './components/profile/config/payment-methods/payment-methods.component';
import { DeleteCardComponent } from './components/shared/delete-card/delete-card.component';
import { ConfirmPayTotemComponent } from './components/checkout/confirm-pay-totem/confirm-pay-totem.component';
import { TotemInfoComponent } from './components/checkout/totem-info/totem-info.component';
import { SelectMethodTotemComponent } from './components/checkout/select-method-totem/select-method-totem.component';
import { QRCodeModule } from 'angularx-qrcode';
import { SocialLoginModule } from '@abacritt/angularx-social-login';
import { CreateCompanyComponent } from './components/control-panel/create-company/create-company.component';
import { DatetimeSelectorComponent } from './components/shared/datetime-selector/datetime-selector.component';
import { PassesListComponent } from './components/passes/passes-list/passes-list.component';
import { PassDetailComponent } from './components/passes/pass-detail/pass-detail.component';
import { PassPurchaseComponent } from './components/passes/pass-purchase/pass-purchase.component';
import { PassSelectDialogComponent } from './components/passes/pass-select-dialog/pass-select-dialog.component';
import { OwnerAbonosComponent } from './components/page-owner/owner-abonos/owner-abonos.component';
registerLocaleData(localeEs);

export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    FooterComponent,
    HeaderComponent,
    LoginComponent,
    RegisterComponent,
    EventComponent,
    SearchComponent,

    CategoryPageComponent,
    NotFoundPageComponent,
    PaginatorResultsComponent,
    PrivacyComponent,
    CookiesComponent,
    FiltersComponent,
    CustomCalendarComponent,
    PageOwnerComponent,
    ContactFormComponent,
    SuggestionsComponent,
    WarningComponent,
    TermsConditionsComponent,
    FaqsComponent,
    AboutUsComponent,
    WhoWeAreComponent,
    CityblogComponent,
    DetailPodsComponent,
    LastPostsComponent,
    ListMapComponent,
    InfoCardComponent,
    DescriptionLokComponent,
    MainMenuComponent,
    StepCheckoutComponent,
    ConfirmPayComponent,
    WaitingPayComponent,
    CheckoutPageComponent,
    DatesHoursComponent,
    NewTicketComponent,
    ProfileComponent,
    FavoritesComponent,
    ProfileFavComponent,
    EventsFavComponent,
    InteresesComponent,
    EditProfileComponent,
    NotificationsComponent,
    MyMembershipComponent,
    AbonoCardComponent,
    // LinkMembershipCardComponent,
    SeasonPassSignupComponent,
    // SeasonPassSignupClosedComponent,
    TicketsProfileComponent,
    TicketDetailComponent,
    TicketsListComponent,
    EventsListComponent,
    ChangePasswordComponent,
    InputHourComponent,
    DefaultCalendarComponent,
    CardValidateComponent,
    // HideEventComponent,
    LegalComponent,
    CookiesTermsComponent,
    ImageMapComponent,
    CartCheckoutComponent,
    SeasonPassCheckoutComponent,
    NewPasswordComponent,
    NominativeHolderComponent,
    SubscriberFrontComponent,
    ChangeNameComponent,
    StatusPayComponent,
    SubscriptionsComponent,
    PaylandsTemplateComponent,
    PaymentSuccessComponent,
    PaymentErrorComponent,
    PaymentFailedDialogComponent,
    ChatbotComponent,
    InfoConditionsComponent,
    PaymentMethodsComponent,
    DeleteCardComponent,
    ConfirmPayTotemComponent,
    TotemInfoComponent,
    SelectMethodTotemComponent,
    CreateCompanyComponent,
    PassesListComponent,
    PassDetailComponent,
    PassPurchaseComponent,
    PassSelectDialogComponent,
    OwnerAbonosComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CardsModule,
    SwiperModule,
    PickerModule,
    AngularEditorModule,
    LottieModule.forRoot({ player: playerFactory }),
    NgxPayPalModule,
    FallimgModule,
    NgxSkeletonLoaderModule,
    SeatMapModule,
    ControlPanelModule,
    TotemModule,
    SharedModule,
    HammerModule,
    QRCodeModule,
    // Para el <asl-google-signin-button> de SeasonPassSignupComponent (y de
    // LinkMembershipCardComponent cuando estaba activo), que se
    // declara aquí. La configuración del proveedor (SocialAuthServiceConfig con
    // el client id) la aporta CardsModule y sube al injector raíz, así que no
    // hay que repetirla.
    SocialLoginModule
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: LOCALE_ID, useValue: 'es-ES' },
  ],
  bootstrap: [AppComponent],
  exports: [
    CommonModule,
    MaterialModule,
    NgbModule,
    WarningComponent,
    FallimgModule
  ]
})
export class AppModule { }
